import { Class } from '../utils';
import icons from '../resources/icons';
import EsSearcher from './EsSearcher';
/**
 *
 * @class CVR_enhedSearcher Searches Septima virk.dk data service.
 * @extends Septima.Search.Searcher
 * @constructs Septima.Search.CVR_enhedSearcher
 * @param {Object} options arcGisSearcher expects these properties:<br/>
 * @param {string} options.host "Service endpoint (SpatialSuite Url) eg.: [http:]//sps-demo.septima.dk[:80]. Protocol and port are optional"
 * @param {string} options.datasources Comma separated list of indexed data sources to search. Default: "*"
 *
 *
 */

export default Class(EsSearcher, {
  initialize: function initialize(options) {
    options.fields = options.fields || ['navn_tekst', 'beliggenhedsadresse_vejnavn', 'beliggenhedsadresse_postdistrikt', 'beliggenhedsadresse_postnr', 'pnr', 'wkt'];
    options.searchindexServiceUrl = 'https://new-searchindex.septima.dk/';
    var searchindexToken = options.searchindexToken;
    options.index = searchindexToken + '/cvr/produktionsenheder';

    if (options.kommunekode) {
      var municipalities = options.kommunekode.split(' ');
      options.filterTerm = {
        'beliggenhedsadresse_kommune_kode': municipalities
      };
    } else if (options.filter) {
      options.filterTerm = options.filter;
    }

    options.source = "cvr";
    options.type = "produktionsenhed";
    if (typeof options.singular === 'undefined') options.singular = 'Produktionsenhed';
    if (typeof options.plural === 'undefined') options.plural = 'Produktionsenheder';
    options.idField = 'pnr';
    EsSearcher.prototype.initialize.apply(this, [options]);
    this.iconURI = icons.searchers.cvr; //this.addCustomButtonDef({"buttonText":"cvr.dk", "buttonImage": this.iconURI, "callBack": (result)=> this.openCvrLink(result)});
  },

  /*
  openCvrLink: function (result) {
  window.open('http://datacvr.virk.dk/data/visenhed?enhedstype=produktionsenhed&id='+result.data.pnr[0], "_blank");
  },
  */
  createQuery: function createQuery(queryString) {
    var esQuery;
    esQuery = {
      "bool": {
        "should": [{
          "multi_match": {
            "query": queryString,
            "type": "cross_fields",
            "operator": "and",
            "fields": ["hovedbranche_tekst", "navn_tekst", "pnr", "virksomhed_cvrnr"]
          }
        }, {
          "match_phrase": {
            "navn_tekst": {
              "boost": 5,
              "query": queryString
            }
          }
        }, {
          "match": {
            "navn_tekst": {
              "boost": 4,
              "operator": "or",
              "query": queryString
            }
          }
        }, {
          "match": {
            "beliggenhedsadresse_vejnavn": {
              "boost": 3,
              "query": queryString
            }
          }
        }, {
          "match_phrase": {
            "hovedbranche_tekst": {
              "boost": 2,
              "query": queryString
            }
          }
        }]
      }
    };
    return esQuery;
  },
  getGeometry: function getGeometry(hit) {
    if (hit.fields.wkt !== undefined) return this.translateWktToGeoJsonObject(hit.fields.wkt[0]);
    return null;
  },
  getDescription: function getDescription(hit) {
    return hit.fields.beliggenhedsadresse_vejnavn[0] + ' ' + hit.fields.beliggenhedsadresse_postnr[0] + ' ' + hit.fields.beliggenhedsadresse_postdistrikt[0];
  },
  getDisplayName: function getDisplayName(hit) {
    return hit.fields.navn_tekst[0];
  },
  CLASS_NAME: 'Septima.Search.CVR_enhedSearcher'
});